module.exports = __webpack_public_path__ + "static/media/attend_event.ac125f1a.svg";